import { defineStore } from "pinia";
import type { Tenant } from "@/lib/tenant";

export const useTenantStore = defineStore("tenant", {
  state: () => ({ tenant: null as Tenant | null }),
  getters: {
    id: (s) => s.tenant?.id ?? "",
    slug: (s) => s.tenant?.slug ?? "",
    isAdmin: (s) => s.tenant?.is_admin ?? false,
    nome: (s) => s.tenant?.nome_fantasia ?? "Aferi",
    logoUrl: (s) => s.tenant?.logo_url ?? null,
    logoMode: (s) => s.tenant?.logo_mode ?? "image_text",
    modulosAtivos: (s) => s.tenant?.modulos_ativos ?? [],
  },
  actions: {
    set(t: Tenant) {
      this.tenant = t;
    },
    hasModulo(slug: string): boolean {
      const list = this.tenant?.modulos_ativos ?? [];
      return list.length === 0 || list.includes(slug);
    },
  },
});
